/*
 * Purpose: Block Types — Swiss-army primitives; contextual configuration defines each block in a Mission
 * Last modified: 2026-06-27 | Agent
 * Completeness: 100
 */

export type BlockCategory =
  | 'start'
  | 'goal'
  | 'agent'
  | 'drone'
  | 'tube'
  | 'branded'
  | 'trigger'
  | 'tool'
  | 'action';

/** category.subtype → display name */
export const BLOCK_TYPE_LABELS: Record<string, string> = {
  'start.mission': 'START Block',
  'goal.outcome': 'GOAL Block',
  'agent.assistant': 'Agent Block',
  'drone.remote': 'Drone Block',
  'tube.journey': 'Journey Tube',
  'branded.bdna_lock': 'BDNA Lock Block',
  'branded.squadbox_mega': 'Squadbox Mega Block',
  'branded.thrpy_dictation': 'THRPY Dictation Block',
  'branded.sensaffect_emotion': 'SensAfffect Emotion Detection Block',
  'trigger.manual': 'Manual Trigger Block',
  'trigger.gmail_inbound': 'Gmail Trigger Block',
  'trigger.webhook': 'Webhook Trigger Block',
  'trigger.timer': 'Timer Trigger Block',
  'trigger.api': 'API Trigger Block',
  'tool.transform': 'Transform Block',
  'tool.http': 'HTTP Block',
  'tool.conditional': 'Conditional Block',
  'tool.delay': 'Delay Block',
  'action.storage': 'Storage Block',
  'action.notification': 'Notification Block',
  'action.log': 'Log Block',
  'action.webhook': 'Webhook Action Block',
};

export const BLOCK_CATEGORY_TYPE_LABELS: Record<BlockCategory, string> = {
  start: 'START Block',
  goal: 'GOAL Block',
  agent: 'Agent Block',
  drone: 'Drone Block',
  tube: 'Journey Tube',
  branded: 'Branded Block',
  trigger: 'Trigger Block',
  tool: 'Tool Block',
  action: 'Action Block',
};

export function getBlockTypeLabel(category: string, subtype: string): string {
  const key = `${category}.${subtype}`;
  if (BLOCK_TYPE_LABELS[key]) return BLOCK_TYPE_LABELS[key];
  const words = subtype
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
  return `${words} Block`;
}

export function getBlockCategoryTypeLabel(category: string): string {
  if (category in BLOCK_CATEGORY_TYPE_LABELS) {
    return BLOCK_CATEGORY_TYPE_LABELS[category as BlockCategory];
  }
  return 'Block';
}
